<template>
  <section>

    <div class="login-for-sso" v-loading.fullscreen="loginLoad" element-loading-text="正在登录认证中..."></div><!-- element-loading-spinner="nbcb-icon-load" -->



  </section>
</template>

<script>
export default {
  data(){
    return {
      loginLoad: true,
    }
  },
  methods: {
    loginForSso(qsObj){
      let data = null
      switch ('string') {   // 组装请求参数及转换格式
        case typeof(qsObj.userkey):    // 中台
          console.log(qsObj)
          data = qsObj.userkey
          break;
        default:    // 缺省值获取全部qs数据
          data = qsObj
          break;
      }
      this.loginAjax(data)
    },

    // 请求单点登录
    loginAjax(loginData){
      this.axios.post('/accessApi/getToken',{userKey:loginData} ).then((res)=>{
        console.log(res)
        if (res.code === 200) {
          this.$notification.success({message:'登录成功！'})
          this.$store.commit('user/login', res.data)
          this.$store.commit('common/updatePageInfo')
          // this.$store.commit('navTabReset')
          this.$router.push('/')
          sessionStorage.setItem('errorCodes', JSON.stringify([]))
        } else  {
          this.$router.push('/login')
        }
      }).catch((err)=>{
        console.log(err.message);
        this.$router.push('/login')
      })
      // 请求加密公钥
      this.axios.post('/key','').then((res) => {
        console.log(res)
        if (res.code===200) {
          this.$store.commit('common/updatePublicKey',res.data||'')
          this.$encrypt.setPublicKey(res.data)
        }
      })
    },


  },
  beforeMount(){
    // console.log(this.$route.query.code);
    this.loginForSso(this.$route.query)
  },
}
</script>

<style lang="scss" scoped>
</style>